import React from 'react';

import DEPRECATED_ClauseLibrary from '~/components/ClauseLibrary/index';
import { ClauseLibrary } from '~/features/clause-library/ClauseLibrary';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { withPermissions } from '~/hocs/withPermissions';

const ClauseLibraryEditPermission = {
  resourceId: 'clause_library',
  resourceType: 'edit',
};

const Page = ({
  checkPermission,
}: {
  checkPermission: (resourceId: string, resourceType: string) => boolean;
}) => {
  const hasEditPermission = checkPermission(
    ClauseLibraryEditPermission.resourceId,
    ClauseLibraryEditPermission.resourceType,
  );
  const enableV2 = useFlag(FlagType.ClauseLibraryAiSuggest);
  return enableV2 ? (
    <ClauseLibrary />
  ) : (
    <DEPRECATED_ClauseLibrary hasEditPermission={hasEditPermission} />
  );
};

export default withPermissions(Page, [ClauseLibraryEditPermission]);
